var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavGallery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .454h29.895V31H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.395 29H4.5A2.503 2.503 0 012 26.5V9.943c0-1.379 1.121-2.5 2.5-2.5h20.895c1.378 0 2.5 1.121 2.5 2.5v.784h-4.688a1 1 0 100 2h4.688V26.5c0 1.379-1.122 2.5-2.5 2.5zM10.751 2.595a.939.939 0 00.02-.141h8.353c.003.048.01.095.02.141l.628 2.848h-9.649l.628-2.848zm14.644 2.848H21.82l-.703-3.191c-.065-1.002-.89-1.798-1.895-1.798h-8.549c-1.005 0-1.829.796-1.895 1.798l-.703 3.191H4.5a4.506 4.506 0 00-4.5 4.5V26.5C0 28.981 2.02 31 4.5 31h20.895c2.481 0 4.5-2.019 4.5-4.5V9.943c0-2.481-2.019-4.5-4.5-4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.54 24.188a5.232 5.232 0 01-5.226-5.226 5.232 5.232 0 015.226-5.224 5.231 5.231 0 015.225 5.224 5.231 5.231 0 01-5.225 5.226m0-12.45c-3.984 0-7.226 3.24-7.226 7.224 0 3.985 3.242 7.226 7.226 7.226s7.225-3.241 7.225-7.226c0-3.983-3.24-7.224-7.225-7.224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.54 16.084a2.878 2.878 0 100 5.756 2.878 2.878 0 000-5.756"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGallery);
export default __webpack_public_path__ + "static/media/nav-gallery.70d2106ca4c2ce9e3ca2455f5ac560e3.svg";
export { ForwardRef as ReactComponent };